import { render, staticRenderFns } from "./BellEdit.vue?vue&type=template&id=694fca3c&scoped=true&"
import script from "./BellEdit.vue?vue&type=script&lang=js&"
export * from "./BellEdit.vue?vue&type=script&lang=js&"
import style0 from "./BellEdit.vue?vue&type=style&index=0&id=694fca3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694fca3c",
  null
  
)

export default component.exports